export default __webpack_public_path__ + "static/img-ef-11-28f195a1503569a85089b18f7cf84445.png";